import React from "react"

import { ExpandableTemplateVariableText } from "@/components/shared/ExpandableTemplateVariableText"

import type { EditableTestCase } from "../../../model"
import { TextCell } from "./TextCell"

interface TestCaseDescriptionCellProps {
  testCase: EditableTestCase
  isExpanded: boolean
  onUpdate: (updates: Partial<EditableTestCase>) => void
  width: string
  isMarkedForDeletion?: boolean
}

export const TestCaseDescriptionCell: React.FC<
  TestCaseDescriptionCellProps
> = ({ testCase, isExpanded, onUpdate, width, isMarkedForDeletion }) => {
  return (
    <TextCell
      testCase={testCase}
      field="description"
      width={width}
      isExpanded={isExpanded}
      onUpdate={onUpdate}
      placeholder="Basic inquiry about ..."
      ariaLabel="Edit description"
      isMarkedForDeletion={isMarkedForDeletion}
      renderEdit={(value, onChange) => (
        <ExpandableTemplateVariableText
          value={value}
          onChange={onChange}
          isExpanded
          focusOnMount
          placeholder="Basic inquiry about ..."
          className="text-sm text-coval-text"
        />
      )}
    />
  )
}
